import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export function useFetch(path, { auto = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(auto);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(path);
      setData(res.data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    if (auto) refetch();
  }, [refetch, auto]);

  return { data, loading, error, refetch, setData };
}
